import { render, staticRenderFns } from "./RouteTable.vue?vue&type=template&id=52d6b5bb&scoped=true&"
import script from "./RouteTable.vue?vue&type=script&lang=js&"
export * from "./RouteTable.vue?vue&type=script&lang=js&"
import style0 from "./RouteTable.vue?vue&type=style&index=0&id=52d6b5bb&prod&lang=css&"
import style1 from "./RouteTable.vue?vue&type=style&index=1&id=52d6b5bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6b5bb",
  null
  
)

export default component.exports